import styled from 'styled-components'
import { buttonReset } from './fragments'
import { iPadUp } from './mediaQueries'
import { fontSize, titleFontSize } from './variables'

export const linkStyles = `
    text-decoration: underline;
    &:hover,
    &:active {
      ${iPadUp} {
        font-weight: bold;
      }
    }
`

export const H3 = styled.h3`
  font-weight: bold;
  line-height: 1.5;
  margin: 0;
  ${fontSize};
`

export const Button = styled.button`
  ${buttonReset}
`

export const A = styled.a`
  color: inherit;
  -webkit-appearance: none;
  ${linkStyles}
`

export const ButtonLink = styled.button`
  ${buttonReset}
  ${linkStyles}
`

export const P = styled.p`
  font-weight: normal;
  line-height: 1.5;
  margin: 0;
  ${fontSize};
`

export const H2 = styled.h2`
  font-weight: normal;
  line-height: 1.5;
  margin: 0;
  width: 100%;
  ${fontSize}
`

export const H1 = styled.h1`
  line-height: 1.5;
  margin: 0;
  ${titleFontSize};
`
